import { useEffect, useState } from "react";
import {
  Container,
  Content,
  Title,
} from "./style";
import {
  Card,
  CardContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import {
  ArrowDownward,
} from "@mui/icons-material";
import moment from "moment";
import { Error } from "../Error";
import { Header } from "../Header";
import { apiOperation, headers } from "../../services/api";
import { Documento } from "../../models/analise";
import { Loading } from "../Loading";
import { getSessionUser } from "../../utils/users";
import { IUser } from "../Login/ILogin";
import { AnaliseLote, ResultadoAnaliseLote } from "../../models/analiseLote";

let usuarioLogado: IUser | null = null;

export const CustomerTable = () => {
  const [historyList, setHistoryList] = useState<AnaliseLote[]>([]);
  const [showLoading, setShowLoading] = useState(true);
  const [pagination, setPagination] = useState({
    paginaCorrente: 0,
    quantidadePaginas: 0,
    tamanhoPagina: 10,
    quantidadeRegistros: 0,
  });

  const [errorApi, setErrorApi] = useState({
    message: "",
    title: "",
    state: false,
  });

  const handleChangeRowsPerPage = (event: any) => {
    setPagination({
      ...pagination,
      paginaCorrente: 0,
      tamanhoPagina: event.target.value | 10,
    });
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPagination({
      ...pagination,
      paginaCorrente: newPage,
    });
  };

  const getHistory = async () => {
    try {
      const config = {
        headers: headers(),
      };
      setShowLoading(true);
      let urlString = `analise/listar-lotes
				?pagina=${pagination.paginaCorrente}
				&registrosPorPagina=${pagination.tamanhoPagina}`;

      const { data } = await apiOperation.get<ResultadoAnaliseLote>(urlString, config);

      if (!data.erro) {
        setHistoryList([...data.valor.dados]);
        setPagination({
          ...pagination,
          quantidadePaginas: data.valor.quantidadePaginas,
          quantidadeRegistros: data.valor.quantidadeRegistros,
        });
        setShowLoading(false);
      } else {
        setErrorApi({
          title: "Não foi possivel se conectar a API no momento.",
          state: true,
          message: data.erros?.join("<hr />"),
        });
        setShowLoading(false);
      }
    } catch (error: any) {
      setErrorApi({
        title: `API Não disponivel`,
        message: `Caso o problema continue informe o seguinte erro: ${error?.response?.status}-${error?.response?.statusText}`,
        state: true,
      });
      setShowLoading(false);
    }
  };

  const Download = async (params = "") => {
    try {
      const config = {
        headers: headers(),
      };

      setShowLoading(true);
      let urlString = `analise/relatorio-lote
				?documentoId=${params}`;

      const { data } = await apiOperation.get<string>(urlString, config);
      window.open(data);

      setShowLoading(false);
    } catch (error: any) {
      setErrorApi({
        title: `API Não disponivel`,
        message: `Falha ao baixar relatório!`,
        state: true,
      });
      setShowLoading(false);
    }
  };

  useEffect(() => {
    getHistory();

    usuarioLogado = getSessionUser();
  }, [pagination.paginaCorrente, pagination.tamanhoPagina]);

  return (
    <>
      <Header />
      <Container>
        <Content>
          <Title>Histórico de Análises em Lote</Title>
        </Content>
        <Card sx={{ minWidth: 275 }}>
          {showLoading ? (
            <Loading hidden={!showLoading} />
          ) : (
            <>
              <CardContent>
                <TableContainer>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Solicitante</TableCell>
                        <TableCell align="left">Data da Consulta</TableCell>
                        <TableCell align="center">Análises</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center">Relatório</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyList.map((item) => (
                        <TableRow
                          key={item.documentoId}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          hover
                        >
                          <TableCell align="left">
                            {item.solicitante}
                          </TableCell>
                          <TableCell align="left">
                          {moment(item.dataConsulta).format("DD/MM/YYYY - HH:mm")}
                          </TableCell>
                          <TableCell align="center">
                            {item.analises}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ whiteSpace: "break-spaces" }}
                          >
                            <div
                              style={{
                                backgroundColor:
                                  item.status === "Concluído"
                                    ? "var(--success)"
                                      : "var(--info)",
                                borderRadius: "15px",
                                width: "fit-content",
                                padding: "inherit",
                                color: "var(--text-on-inverse)",
                                margin: "auto",
                              }}
                            >
                              {item.status}
                            </div>
                          </TableCell>
                          <TableCell align="center">
                            {item.status !== "Concluído" ? (
                              "-"
                            ) : (
                              <IconButton
                                onClick={() => Download(item.documentoId)}
                                color="primary"
                                aria-label="Visualizar"
                              >
                                <ArrowDownward />
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={pagination.quantidadeRegistros}
                    page={pagination.paginaCorrente}
                    onPageChange={handleChangePage}
                    rowsPerPage={pagination.tamanhoPagina}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={"Registros Por Páginas: "}
                  />
                </TableContainer>
              </CardContent>
            </>
          )}
        </Card>
        <Error
          hasOpen={errorApi.state}
          handleClose={() => setErrorApi({ ...errorApi, state: false })}
          errorMsg={errorApi.message}
          title={errorApi.title}
        />
      </Container>
    </>
  );
};
